import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { useCallback } from 'react';

import { en } from '@/intl/en';

export type TranslationBlock = typeof en;

export const useAppFormatMessage = () => {
    const { formatMessage } = useIntl();

    return useCallback(
        <
            PrimaryId extends keyof TranslationBlock,
            SecondaryId extends keyof TranslationBlock[PrimaryId],
            TertiaryId extends keyof TranslationBlock[PrimaryId][SecondaryId],
            QuaternaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId],
            QuinaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId],
            SenaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId],
            SeptenaryId extends
                keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId][SenaryId],
        >(
            primaryId: PrimaryId,
            secondaryId?: SecondaryId,
            tertiaryId?: TertiaryId,
            quaternaryId?: QuaternaryId,
            quinaryId?: QuinaryId,
            senaryId?: SenaryId,
            septenaryId?: SeptenaryId
        ) => {
            let translationKey: string = `${primaryId}`;
            if (secondaryId) {
                translationKey = `${translationKey}.${String(secondaryId)}`;
                if (tertiaryId) {
                    translationKey = `${translationKey}.${String(tertiaryId)}`;
                    if (quaternaryId) {
                        translationKey = `${translationKey}.${String(quaternaryId)}`;
                        if (quinaryId) {
                            translationKey = `${translationKey}.${String(quinaryId)}`;
                            if (senaryId) {
                                translationKey = `${translationKey}.${String(senaryId)}`;
                                if (septenaryId) {
                                    translationKey = `${translationKey}.${String(septenaryId)}`;
                                }
                            }
                        }
                    }
                }
            }
            return formatMessage({
                id: translationKey,
            });
        },
        [formatMessage]
    );
};

export const useAppFormatMessageWithValues = () => {
    const { formatMessage } = useIntl();

    return useCallback(
        <
            PrimaryId extends keyof TranslationBlock,
            SecondaryId extends keyof TranslationBlock[PrimaryId],
            TertiaryId extends keyof TranslationBlock[PrimaryId][SecondaryId],
            QuaternaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId],
            QuinaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId],
            SenaryId extends keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId],
            SeptenaryId extends
                keyof TranslationBlock[PrimaryId][SecondaryId][TertiaryId][QuaternaryId][QuinaryId][SenaryId],
        >(
            primaryId: PrimaryId,
            values?: Parameters<ReturnType<typeof useIntl>['formatMessage']>[1],
            secondaryId?: SecondaryId,
            tertiaryId?: TertiaryId,
            quaternaryId?: QuaternaryId,
            quinaryId?: QuinaryId,
            senaryId?: SenaryId,
            septenaryId?: SeptenaryId
        ) => {
            let translationKey: string = `${primaryId}`;
            if (secondaryId) {
                translationKey = `${translationKey}.${String(secondaryId)}`;
                if (tertiaryId) {
                    translationKey = `${translationKey}.${String(tertiaryId)}`;
                    if (quaternaryId) {
                        translationKey = `${translationKey}.${String(quaternaryId)}`;
                        if (quinaryId) {
                            translationKey = `${translationKey}.${String(quinaryId)}`;
                            if (senaryId) {
                                translationKey = `${translationKey}.${String(senaryId)}`;
                                if (septenaryId) {
                                    translationKey = `${translationKey}.${String(septenaryId)}`;
                                }
                            }
                        }
                    }
                }
            }
            return formatMessage(
                {
                    id: translationKey,
                },
                values
            );
        },
        [formatMessage]
    );
};
